import { Logo } from "@nexxt/ui";
import { m } from "../../paraglide/messages.js";

export function Footer() {
  return (
    <footer className="footer">
      <p className="footer-motto">{m.footer_motto()}</p>
      <p className="footer-guests">{m.footer_guests()}</p>
      <div className="footer-end">
        <Logo variant="tag" className="footer-tag" />
        <span>{m.footer_made()}</span>
      </div>
    </footer>
  );
}
